<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <gd-modal
      ref="optinForm"
      name="optinForm"
      width="660px"
    >
      <div v-if="!integrationModal">
        <div class="flex justify-start text-2xl font-semibold pl-5 pt-5">
          {{$t('frontend_groovevideo_videos_step3_optin_form')}}
        </div>
        <div class="flex flex-row items-start justify-start pt-5 pl-5">
          <gd-tabs
            :tabs="tabs"
            :current-tab="currentTab"
            :tab-active-class="'active-nav-tab'"
            :tab-class="'w-auto h-8 px-4 nav-tab'"
            @onClick="handleTabChange"
            :key="
              this.$t(
                'frontend_signup_forms'
              )
            "
          />
        </div>
        <div v-if="currentTab === 'form'">
          <div class="flex flex-col items-start justify-start p-5">
            <div class="flex flex-col mb-4">
              <label class="font-semibold text-sm text-grey-700 mb-2 text-left">
                {{ $t('frontend_groovevideo_videos_step3_display_At') }}
              </label>
              <div class="flex mx-1">
                <div class="w-1/3 h-12 flex flex-row mr-2">
                  <select
                    v-model="localmodel.hours"
                    value="localmodel.hours"
                    :validator="$v.localmodel.hours"
                    class="w-full h-10 outline-none rounded-lg text-grey-500 bg-white px-2 border border-grey-200"
                  >
                    <option v-for="index in 24" :key="index">
                      {{ index - 1 }}
                    </option>
                  </select>
                  <span class="ml-2 mt-2 text-grey-700">H</span>
                </div>
                <div class="w-1/3 h-12 flex flex-row mr-2">
                  <select
                    v-model="localmodel.minutes"
                    value="localmodel.minutes"
                    :validator="$v.localmodel.minutes"
                    class="w-full h-10 outline-none text-grey-500 bg-white rounded-lg px-2 border border-grey-200"
                  >
                    <option v-for="index in 60" :key="index">
                      {{ index - 1 }}
                    </option>
                  </select>
                  <span class="ml-2 mt-2 text-grey-700">M</span>
                </div>
                <div class="w-1/3 h-12 flex flex-row mr-2">
                  <select
                    v-model="localmodel.seconds"
                    :validator="$v.localmodel.seconds"
                    value="localmodel.seconds"
                    class="w-full h-10 outline-none rounded-lg px-2 border border-grey-200 text-grey-500 bg-white"
                  >
                    <option v-for="index in 60" :key="index">
                      {{ index - 1 }}
                    </option>
                  </select>
                  <span class="ml-2 mt-2 text-grey-700">S</span>
                </div>
              </div>
            <div class="flex items-start error mb-2">
              {{reject}}
            </div>
            </div>
            <div class="flex flex-col mb-4 w-full">
              <label class="font-semibold text-sm text-grey-700 mb-2 text-left">
                {{ $t('frontend_groovevideo_videos_step3_headline_text') }}
              </label>
              <text-input
                v-model="localmodel.headingText"
                :validator="$v.localmodel.headingText"
                value="localmodel.headingText"
                :attribute="$t('frontend_groovevideo_headline')"
                :placeholder="
                  $t('frontend_groovevideo_videos_step3_enter_headline_text')
                "
              />
            </div>
            <div class="flex flex-row mt-2 mb-4 mx-1">
              <label class="font-semibold text-sm text-grey-700 mb-2 mr-5">
                {{ $t('frontend_groovevideo_videos_step3_show_skip_button') }}
              </label>
              <gd-toggle v-model="localmodel.showSkipButton" />
            </div>
          </div>
        </div>
        <div v-else-if="currentTab === 'integrations'">
          <div v-if="localmodel.headingText.length < 1" class=" text-left text-grey-dark m-6">{{
          $t('frontend_groovevideo_addnew_video_disabled_integrations')
        }}
          </div>
          <div v-else>
            <div class="flex flex-col p-5">
              <div class="flex flex-row items-center">
                <gd-button
                  primary
                  class="add-integrations-btn text-xl"
                  @click="{integrationModal = true}"
                >
                  +
                </gd-button>
                <span class="pl-3 font-semibold">
                  {{$t('frontend_groovevideo_videos_step3_add_integrations')}}
                </span>
              </div>
              <div 
                v-if="allIntegrations.length != 0"
                class="custom-scrollbars overflow-auto mt-4"
                style="max-height: calc(100vh - 320px);
                       min-height: 130px"
              >
                <div v-for="(item,index) in allIntegrations" :key="index" class="mb-4">
                  <div v-for="(integration,ind) in item" :key="ind" class="flex flex-row justify-between border border-grey-300 px-2 py-3 my-1 mr-3 rounded-md align-center">
                    <div class="ml-3 font-semibold">
                      {{index}}
                    </div>
                    <div class="flex flex-row">
                      <span class="flex border border-grey-200 bg-grey-200 h-7 font-normal text-grey-800 rounded-md py-1 px-2 text-xs">
                        {{integration.name}}
                      </span>
                      <dropdown-button class="flex ml-3 mt-1 flex-row">  
                        <span slot="link" class="text-grey-500" >
                            <i class="fas fa-ellipsis-v cursor-pointer"></i>
                        </span>
                        <div
                          slot="dropdown"
                          class="
                            bg-white
                            shadow
                            rounded
                            border border-grey-300
                            cursor-pointer
                            text-xs
                            mt-4
                            -inset-8
                            text-left
                          "
                          style="
                            position: absolute;
                            right: 0;
                            top: 1px
                          "
                        >
                          <div
                            class="
                              no-underline
                              block
                              p-2
                              text-md
                              font-normal
                              bg-white
                            "
                            @click="openIntegration(index, integration.slug)"
                          >
                            {{ $t('frontend_edit') }}
                          </div>
                          <div
                            class="
                              no-underline
                              block
                              p-2
                              text-md
                              font-normal
                              bg-white
                            "
                            @click="deleteIntegration(index, integration)"
                          >
                            {{ $t('frontend_delete') }}
                          </div>
                        </div>
                      </dropdown-button>  
                    </div>
                  </div>
                </div>
              </div>
              <div v-else
                   class="flex items-start my-4 ml-2">
              {{$t('frontend_groovevideo_videos_step3_no_integrations')}}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row items-center justify-center pb-5">
          <gd-button size="auto" class="py-4 px-8 mr-2" @click="closeOptinForm">
            {{ $t('frontend_cancel') }}
          </gd-button>
          <gd-button
            size="auto"
            primary
            class="py-4 px-8 mr-2"
            @click="saveOptionForm"
          >
            {{ $t('frontend_groovevideo_videos_step3_done') }}
          </gd-button>
        </div>
      </div>
      <div v-else style="min-height: 80vh">
        <div class="flex justify-between p-5">
          <div class="flex align-center">
            <div class="cursor-pointer text-xl p-1" @click="goBack">
              <i class="fas fa-chevron-left text-grey-500"></i>
            </div>
            <span class="text-2xl pl-3">{{$t('frontend_groovevideo_videos_step3_add_integrations')}}</span>
          </div>
          <gd-button
            primary
            size="auto"
            class="py-4 px-8 mr-2"
            @click="saveIntegration"
          >
            {{ $t('frontend_save') }}
          </gd-button>
        </div>
        <div class="p-6 mb-5">
          <div class="flex flex-col align-modal">
            <label class="font-semibold text-sm text-grey-700 mb-1 text-left">
              {{$t('frontend_groovevideo_videos_step3_integration_type')}}
            </label>
            <div class="w-full text-sm">
              <div>
                <gd-dropdown
                  :options="integrationTypes"
                  v-model="selectedIntegration"
                  class="text-left mb-4"
                  size="full"
                  :placeholder="$t('frontend_groovevideo_videos_step3_integration_type_placeholder')"
                  @change="{event = null}"
                ></gd-dropdown>
              </div>
            </div>
            <div v-if="selectedIntegration">
              <div v-if="selectedIntegration == 'GrooveMail'">
                <mail-tab
                  ref="mail"
                  :model="video"
                  :minutes="localmodel.minutes"
                  :optinId="ctaIndex"
                  :watchedUntil="watchedUntilPoints"
                  :event="event"
                />
              </div>
              <div v-if="selectedIntegration == 'GrooveMember'">
                <member-tab
                  ref="member"
                  :model="video"
                  :minutes="localmodel.minutes"
                  :optinId="ctaIndex"
                  :watchedUntil="watchedUntilPoints"
                  :event="event"
                />
              </div>
              <div v-if="selectedIntegration == 'Integrations'">
                <integration-tab
                  ref="integration"
                  :model="video"
                  :minutes="localmodel.minutes"
                  :optinId="ctaIndex"
                  :watchedUntil="watchedUntilPoints"
                  :event="event"
                />
              </div>
              <div v-if="selectedIntegration == 'Webhook'">
                <webhook-tab
                  ref="webhook"
                  :model="video"
                  :minutes="localmodel.minutes"
                  :optinId="ctaIndex"
                  :watchedUntil="watchedUntilPoints"
                  :event="event"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators';
import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import MailTab from './integration/mail';
import MemberTab from './integration/member';
import WebhookTab from './integration/webhook';
import IntegrationTab from './integration/otherIntegration';
import Swal from 'sweetalert2';

export default {
  data(){
    return {
      loaderColor: themeConfig.appPrimaryColor,
      isLoading: false,
      fullPageLoader: true,
      localmodel: this.model,
      currentTab: 'form',
      integrationModal: false,
      ctaChanged: false,
      selectedIntegration: '',
      event: null,
      reject: '',
      allIntegrations: {},
      watchedUntilPoints: [],
      integrationTypes: [
        {
          text: this.$t('frontend_groovewebinar_groovemail_integration'),
          value: 'GrooveMail',
        },
        {
          text: this.$t('frontend_groovewebinar_grooovemember_integration'),
          value: 'GrooveMember',
        },
        {
          text: this.$t('frontend_groovewebinar_integration'),
          value: 'Integrations',
        },
        {
          text: this.$t('frontend_product_step8_webhook'),
          value: 'Webhook',
        },
      ],
    };
  },
  props: {
    video: {
      required: true
    },
    model: {
      required: true
    },
    submitOptionForm: {
      required: true
    },
    ctaIndex: {},
  },
  components: {
    Loading,
    MailTab,
    MemberTab,
    WebhookTab,
    IntegrationTab,
  },
  computed: {
    tabs() {
      return [
        {
          title: this.$t('frontend_groovevideo_routes_settings'),
          value: 'form',
        },
        {
          title: this.$t('frontend_groovevideo_integrations'),
          value: 'integrations',
        },
      ];
    },
  },
  watch: {
    localmodel: {
      handler() {
        this.ctaChanged = true;
      },
      deep: true,
    },
  },

  validations: {
    localmodel: {
      hours: {
        required,
        numeric,
        maxLength: maxLength(2),
      },
      minutes: {
        required,
        numeric,
        maxLength: maxLength(2),
      },
      seconds: {
        required,
        numeric,
        maxLength: maxLength(2),
      },
      headingText: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(80),
      },
    },
  },
  async created() {
    this.watchedUntilPoints = await this.video.watchedUntilEvent().$get();
  },
  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    getIntegrationType(type) {
      let integrationType = null;
      
      if(type === 'GrooveMail') {
        integrationType = 'groovemail';
      } else if(type === 'Integrations') {
        integrationType = 'other';
      } else if(type === 'GrooveMember') {
        integrationType = 'groovemember';
      } else if(type === 'Webhook') {
        integrationType = 'webhook';
      }
      
      return integrationType;
    },
    async deleteIntegration(type, integration) {
      const ids = integration.id;
      const integrationType = this.getIntegrationType(type);
      if(integrationType) {
        this.showLoader();

        await axios
          .post(`/delete-event`, { ids, type: integrationType})
          .then((response) => {
            if(
              typeof response.data !== 'undefined' &&
                typeof response.data.status !== 'undefined' &&
                response.data.status
            ) {
                const deleted = this.allIntegrations[type].indexOf(integration);
                if(deleted >= 0) {
                  this.allIntegrations[type].splice(deleted, 1);
                }
            } else {
              this.showDeletionError();
            }
          })
          .catch(() => {
            this.showDeletionError();
          });

        this.hideLoader();
      }
    },
    showDeletionError(text) {
      this.hideLoader();
      Swal.fire({
        type: 'error',
        title: this.$t('frontend_groovevideo_error_title'),
        text: this.$t('frontend_groovevideo_addnew_video_delete_integration_error'),
        reverseButtons: true,
        confirmButtonText: 'Ok',
        cancelButtonText: this.$t('frontend_cancel'),
      });
    },
    closeOptinForm() {
      this.$root.$emit('modal-close', 'optinForm');
      this.currentTab = 'form';
      this.reject = '';
      this.$v.$reset();
    },
    openIntegration(integration, event) {
      this.integrationModal = true;
      this.selectedIntegration = integration;
      this.event = event;
    },
    getLeastWatchedUntilPoint() {
      const points = this.watchedUntilPoints.filter(el => el.optin_id === this.ctaIndex);
      if(points && points.length > 0) {
        let minWatchedUntil = points.reduce(function(prev, curr) {
                    return prev.minutes < curr.minutes ? prev : curr;
                  });
        minWatchedUntil = minWatchedUntil.minutes;
        return minWatchedUntil;
      } else {
        return null;
      }
    },
    async handleTabChange(newTab) {
      const least = this.getLeastWatchedUntilPoint();
      this.$v.localmodel.$touch();
      if(!this.$v.localmodel.$invalid) {
        if(least === null || this.localmodel.minutes < least) {
          if(this.currentTab == 'form' && this.ctaChanged) {
            this.showLoader();
            await this.submitOptionForm(this.ctaIndex, false);
            await this.saveVideo();
            await this.fetchAllIntegrations();
            this.ctaChanged = false;
            this.reject = '';
            this.hideLoader();
          }
          this.currentTab = newTab;
          this.$v.$reset();
        } else {
          this.reject = `Optin Form Time must be less than ${least} minutes`;
        }
      }
    },
    async fetchAllIntegrations() {
      this.showLoader();
      const mailResponse = await this.video.mailIntegration().where('optin_id', this.ctaIndex).get();
      const memberResponse = await this.video.membershipIntegration().where('optin_id', this.ctaIndex).get();
      const otherResponse = await this.video.otherIntegration().where('optin_id', this.ctaIndex).get();
      const webhookResponse = await this.video.webhookIntegration().where('optin_id', this.ctaIndex).get();
      this.allIntegrations = {
        GrooveMail: this.setIntegrationData(mailResponse.data),
        GrooveMember: this.setIntegrationData(memberResponse.data),
        Integrations: this.setIntegrationData(otherResponse.data),
        Webhook: this.setIntegrationData(webhookResponse.data)
      };
      this.hideLoader();
    },
    setIntegrationData(integrations) {
     const data = integrations.map(el => {
      return {id: el.id, slug: el.event.slug}
     });
     const events = [...new Set(data.map(el => el.slug))];
     return events.map(el => this.setEventName(el,data));
    },
    setEventName(slug,data){
      if(slug == 'registration') {
        const id = data.map(el => {
          return el.slug == 'registration' ? el.id : null
        }).filter(el => el);
        return {slug: slug, name:'Registered', id: id};
      } else if(slug == 'completed') {
        const id = data.map(el => {
          return el.slug == 'completed' ? el.id : null
        }).filter(el => el);
        return {slug: slug, name:'Completed', id: id};
      } else if(slug.includes('watchedUntil_')) {
        const time = this.watchedUntilPoints.find(el => el.slug == slug).minutes;
        const id = data.map(el => {
          return el.slug.includes('watchedUntil_') ? el.id : null
        }).filter(el => el);
        return {slug: slug, name:`Watched Until ${time} minutes`, id: id};
      }
    },
    async saveOptionForm() {
      if(!this.ctaChanged) {
        await this.closeOptinForm();
      } else {
        const least = this.getLeastWatchedUntilPoint();
        if(least === null || this.localmodel.minutes < least) {
          await this.submitOptionForm(this.ctaIndex);
          await this.saveVideo();
          this.reject = '';
        } else {
          this.reject = `Optin Form Time must be less than ${least} minutes`;
        }
      }
    },
    async saveIntegration() {
      switch(this.selectedIntegration) {
        case "GrooveMail":
          await this.$refs.mail.saveIntegration();
          break;
        case "Webhook":
          await this.$refs.webhook.saveIntegration();
      }
      this.watchedUntilPoints = await this.video.watchedUntilEvent().$get();
      await this.goBack();
    },
    async goBack() {
      await this.fetchAllIntegrations();
      this.integrationModal = false;
      this.selectedIntegration = '';
    },
    // `this.video` is the editor shell's `model` by reference, so this call
    // persists every unsaved edit in the session. Tell the shell so its Save
    // bar stops claiming there are unsaved changes.
    async saveVideo() {
      await axios.post('/video_details', this.video);
      this.$emit('saved');
    },
  }
}
</script>
<style lang="scss">
  .error {
    text-align: left;
    color: #ea3d5e;
    margin-top: 0.25rem;
    font-size: 0.875rem;
  }
</style>
<style>
.nav-tab {
  background: #fff !important;
  color: #191d3a !important;
  box-shadow: none !important;
  border: 1px #d1d3e0 solid !important;
  border-radius: 6px !important;
  margin-right: 8px;
}
.rounded-md {
  border-radius: 0.375rem !important;
}
.align-modal {
  text-align: start !important;
}
.active-nav-tab {
  color: #fd6481 !important;
  border: 1px #fd6481 solid !important;
}
.add-integrations-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
}

</style>